module.exports = __webpack_public_path__ + "static/media/14.7948e021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/14.jpg
// module id = 82
// module chunks = 0